// extracted by mini-css-extract-plugin
export default {"container":"TopicPage_container__Hlpw8","questions":"TopicPage_questions__jj8jk"};